import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { enumText, translate, isNullOrEmpty, getUserNameToName } from '../../../../utils/util';
import { ENUMS, PERMISSIONS, VISIONS } from '../../../../utils/constants';
import { checkPermission, getVision } from '../../../../services/auth';

const ListItemLotInventoryGeneral = (props) => {
    const manageInventory = checkPermission(props.typeInventory === 'G' ?
        PERMISSIONS.Inventory.General.LoadInventory : PERMISSIONS.Inventory.Rotative.LoadInventory);

    const inventorySupervisor = checkPermission(props.typeInventory === 'G' ?
        PERMISSIONS.Inventory.General.Supervisor : PERMISSIONS.Inventory.Rotative.Supervisor);

    const unlockUserPermission = checkPermission(props.typeInventory === 'G' ?
        PERMISSIONS.Inventory.General.ConnectLotUser : PERMISSIONS.Inventory.Rotative.ConnectLotUser)

    const unlonckUser = unlockUserPermission && !isNullOrEmpty(props.data.startedBy);
    const refresh = manageInventory === true && props.data.status !== ENUMS.eInventoryLotStatus.Loading.value;
    const getStatus = (value) => translate(enumText(ENUMS.eInventoryLotStatus, value), 'inventory');
    const totalItems = () => {
        if (!props.data.lotItems) {
            return '';
        }

        const total = props.data.lotItems.filter((i) => i.status !== ENUMS.eInventoryLotItemStatus.Canceled.value).length;
        let totalFinished = props.data.lotItems.filter((i) => i.status === ENUMS.eInventoryLotItemStatus.Finished.value).length;

        if (getVision() === VISIONS.Jeep) {
            totalFinished = props.data.lotItems.filter((m) => m.status === ENUMS.eInventoryLotItemStatus.Finished.value
                || m.divergent).length;
        }

        return `${totalFinished}/${total}`;
    };

    return (
        <>
            {
                unlonckUser && (
                    <span
                        className="title sixth-text-color right"
                        style={{ position: 'absolute', marginTop: '30px', right: (refresh ? '50px' : '20px'), zIndex: '999' }}
                        onClick={(event) => {
                            event.preventDefault();
                            if (props.onClickUnlonckUser) {
                                props.onClickUnlonckUser(event, props.data);
                            }
                        }}
                    >
                        <i className="material-icons" style={{ cursor: 'pointer' }}>lock_open</i>
                    </span>
                )
            }
            {
                refresh && (
                    <span
                        className="title sixth-text-color right"
                        style={{ position: 'absolute', marginTop: '30px', right: '20px', zIndex: '999' }}
                        onClick={(event) => {
                            event.preventDefault();
                            props.onRefreshLot();
                        }}
                    ><i className="mdi mdi-cached" style={{ cursor: 'pointer' }} />
                    </span>
                )
            }
            <Link
                style={{ display: 'block' }}
                to={props.route}
                onClick={(event) => {
                    if (props.onSelectChange) {
                        props.onSelectChange(event);
                    }
                }}
            >
                <span className="title sixth-text-color">{`${props.data.lotNumber}`}</span>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}> ZONA {props.data.zoneCode} {props.data.zoneDescription}</span>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                    {getStatus(props.data.status)} | <b>{totalItems()} </b> {(manageInventory === true || inventorySupervisor === true) && !isNullOrEmpty(props.data?.startedBy) ? ` | ${props.data.startedBy} - ${getUserNameToName(props.usersFromElog, props.data.startedBy)}` : ''}
                </span>
                <span title={`${props.data.message ? props.data.message : ''}`} className="truncate second-text-color" style={{ color: 'red' }}>{`${props.data.message ? props.data.message : ''}`}</span>
            </Link>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        usersFromElog: state.usersElogReducer.usersElog
    };
};

export default withRouter(connect(mapStateToProps)(withTranslation()(ListItemLotInventoryGeneral)));
